module.exports = __webpack_public_path__ + "media/images/edion/popular/2-91a9b42e71972f81fde0b0a3e4174f0d.png";